export const REPLACED_BECAUSE = {
  later_issue: 'Replaced because the next document has a later issue date.',
  same_issue_date: 'Same issue date as the next document, so it is treated as a copy of it.',
  undated: 'Has no issue date, so a dated document takes over from it.',
  ai_order: 'Put in this order by Guru.',
  person: 'Marked as replaced by a person.',
  later_revision: 'Replaced by a later revision of the same document.',
}

export const replacedBecause = reason => REPLACED_BECAUSE[reason] || null
